/**
 * @class Defines an activity session.
 */
export class CurrentUserModel {
  /**
   * @constructor Creates an instance of an activity session built from an original data from the API.
   * @param {bo} bo is the basic object come from API.
   */
  constructor(bo) {
    this.IdUser = bo.identity.username;
    this.firstName = bo.first_name;
    this.lastName = bo.last_name;
    this.isTeacher = bo.is_teacher;
  }
}
